<template>
  <div>
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="checkboxChange"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        :showOrderType="showOrderType"
      >
        <dict-select
          v-model="skuSalesChannel"
          slot="left"
          :selectedLabel.sync="skuSalesChannelText"
          :body="skuSalesChannelParams"
          url="/sys/common/dict/system"
          :placeholder="$l('tips_select_flip_order_type_data') || '请选择翻单类型'"
          filterable
          style="width:100%"
        />
      </PageHeader>
      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="flipChooseSPUList"
          style="margin-right: 0.8em;"
          @change="reload"
        />
      </template>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <div style="display: flex;justify-content: end;">
      <span slot="footer" class="mt-2">
        <el-badge hidden class="item">
          <el-button size="small" @click="close" class="mr-4">
            {{ $l('INDEX.btn_cancel') || '取消' }}</el-button
          >
        </el-badge>
        <el-badge :value="checkedRowCount" :max="99" class="item">
          <el-button size="small" type="primary" @click="save">{{
            $l('INDEX.btn_save') || '保存'
          }}</el-button>
        </el-badge>
      </span>
    </div>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'

export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, SortFieldsPopover },
  props: {
    orderType: { type: String, default: 'F' },
    showOrderType: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: true,
      updateDesignVisible: false,
      checkedRows: [],
      sortFields: [],
      skuSalesChannel: 'F',
      skuSalesChannelText: 'FBA',
      skuSalesChannelParams: { dictType: 'skuSalesChannel' },
    }
  },
  watch: {
    orderType: {
      handler() {
        this.$refs.header.query()
        this.clearCheckboxRow()
      },
    },
    skuSalesChannel: {
      handler() {
        this.$refs.header.query()
        this.clearCheckboxRow()
      },
    },
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      const isVc = this.orderType == 'V' || this.skuSalesChannel == 'V' ? 'Y' : 'N'
      const isVcList = [isVc]
      this.$api
        .ecomAmzSpuFlipListApi({
          ...form,
          ...this.page,
          isVcList,
          sortFields: this.sortFields,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    checkboxChange(data) {
      this.checkedRows = data
      this.$emit('checkboxChange', this.checkedRowCount)
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    getCheckedRow() {
      return this.checkedRows
    },
    getSkuSalesChannel() {
      return this.skuSalesChannel
    },
    getSkuSalesChannelText() {
      return this.skuSalesChannelText
    },
    close() {
      this.$emit('close')
    },
    save() {
      this.$emit('save')
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
